<template>
  <div id="help" class="fixed-content">
    <tabs :transition="0" v-model="tab">
      <tab title="Actu-SPIADI">
        <news />
      </tab>
      <tab title="FAQ">
        <faq />
      </tab>
    </tabs>
  </div>
</template>
<script>
import news from '@/components/help/news'
import faq from '@/components/help/faq'

export default {
  name: 'help',

  data: function () {
    const tab = parseInt(this.$route.query.tab)
    return {
      tab: (isNaN(tab)) ? 0 : tab
    }
  },

  components: {
    news,
    faq
  },

  watch: {
    '$route.query.tab': function (v) {
      const t = parseInt(v)
      this.tab = (isNaN(t)) ? 0 : t
    }
  }
}
</script>
